module.exports = __webpack_public_path__ + "img/1517446013.41737c8f.jpg";